import { calculateTax } from '../utils';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('calculateBenefits', () => ({
        income: '500,000',
        salary: '75,000',
        incomeTax: '0',
        salaryTax: '0',
        totalSavings: '0',
        dividendValue: '0',
        showResults: false,
        errors: {
          salary: false,
        },
        submitForm() {
          this.validateFields();
          if (this.errors.salary) return;

          const incomeNumber = parseInt(this.income.replaceAll(',', ''));
          const salaryNumber = parseInt(this.salary.replaceAll(',', ''));

          // Calculations
          const incomeTax = calculateTax(incomeNumber);
          const salaryTax = calculateTax(salaryNumber);
          const totalSavings = incomeTax - salaryTax;
          const dividendValue = incomeNumber - salaryNumber;

          this.incomeTax = this.formatValue(incomeTax);
          this.salaryTax = this.formatValue(salaryTax);
          this.totalSavings = this.formatValue(totalSavings);
          this.dividendValue = this.formatValue(dividendValue);

          this.showResults = true;

          // Scroll to results
          const results = document.getElementById('button-results');
          if (results) {
            const offset = results.getBoundingClientRect().top;
            window.scrollTo({
              top: offset + window.scrollY - 200,
              behavior: 'smooth',
            });
          }
        },
        validateFields() {
          if (
            parseInt(this.income.replace(/\D/g, '')) <
            parseInt(this.salary.replace(/\D/g, ''))
          )
            this.errors.salary = true;
          else this.errors.salary = false;
        },
        formatValue(valueNumber) {
          const value = Math.ceil(valueNumber).toString();
          if (value === '') return '';
          const number = value.replace(/\D/g, '');
          const formattedValue = new Intl.NumberFormat().format(number);
          return formattedValue;
        },
        formatIncome(field) {
          this.showResults = false;
          this[field] = this[field].replace(/\D/g, '');
          if (parseInt(this[field]) > 1000000) this[field] = '1000000';
          this[field] = new Intl.NumberFormat().format(this[field]);
        },
      }));
    });
  },
};
